import { artistSearchOrderBy } from '../../../../models/Artist'
import { getLocationFilterParams, normalizeLocationFilter } from '../../../../models/LocationFilter'

export const getParams = (location, eventType, category, genre, sortField) => {
  const tmpParams = {}
  if (location && typeof location === 'object') {
    // A kommune filters on its kommunenummer only - sending its fylke alongside would make
    // the backend widen the search to the whole region.
    Object.assign(tmpParams, getLocationFilterParams(normalizeLocationFilter(location)))
  } else if (location) {
    tmpParams.location = location
  }
  if (eventType) {
    tmpParams.eventType = eventType
  }
  if (category) {
    tmpParams.category = category
  }

  if (genre) {
    tmpParams.genre = genre
  }

  if (sortField) {
    tmpParams.sortField = sortField
    const idx = artistSearchOrderBy.findIndex(order => order.sortField === sortField)
    if (idx !== -1) {
      tmpParams.sortDir = artistSearchOrderBy[idx].sortDir
    }
  }
  return tmpParams
}
